import { useEffect, useState } from "react";

import { ListModuleItemType } from "@/Common/Models/UI/Enums";
import { IListCreateAndEditItemModel } from "../Models/UI/IListCreateAndEditItemModel";
import { IListModel } from "../Models/UI/IListModel";
import { IListsTabModel } from "../Models/UI/IListsTabModel";
import { EmptyContent } from "./EmptyContent";
import { ListItems } from "./ListItems";
import { MultiListsTreeControl } from "./MultiListsTreeControl";

import styles from "./NewListsTab.module.scss";

interface INewListsTabProps {
    model?: IListsTabModel;
    listModel?: IListModel;
    listCreateAndEditItemModel?: IListCreateAndEditItemModel;
}

function NewListsTab(props: INewListsTabProps): JSX.Element {
    const [patientListItemSelected, setPatientListItemSelected] = useState<ListModuleItemType>(null);
    const [searchText] = useState<string>(props.model?.get("SearchText"));
    const [searchMenuOpen, setSearchMenuOpen] = useState(true);
    const [selectedListId, setSelectedListId] = useState(props.model?.get("SelectedItemId"));

    useEffect(() => {
        setSelectedListById();
    }, [props.model, selectedListId]);

    function setSelectedListById(): void {
        const lists = props.model?.get("ClinicalWaitingLists");
        const listId = props.model?.get("SelectedItemId");
        setSelectedListId(listId);
        if (lists && listId) {
            const list = lists.filter(p => p.Id === listId).first();
            if (list)
                setPatientListItemSelected(ListModuleItemType.List);
        }
    }

    return (
        <div
            className="sub-container"
            data-cy="new-lists-tab-container"
        >
            <div className={styles.multiListsContainer}>
                {searchMenuOpen && (
                    <MultiListsTreeControl
                        clinicalWaitingList={props.model?.get("ClinicalWaitingLists")}
                        listItemCallback={() => setPatientListItemSelected(ListModuleItemType.List)}
                        selectedListId={selectedListId}
                        searchTextValue={searchText}
                    />
                )}
                <div className="aside-handle" onClick={() => setSearchMenuOpen(!searchMenuOpen)}>
                    <div className="slide-menu-icon blue"><span /><span /><span />
                    </div>
                </div>
                {(patientListItemSelected === ListModuleItemType.List && props.model?.get("IsAnyListSelected")) ?
                    <ListItems Model={props.listModel} CreateAndEditModel={props.listCreateAndEditItemModel} />
                    : <EmptyContent />
                }
            </div>
        </div>
    );
}

export { NewListsTab };
